import { GetBaseOptions } from 'api/requestsTypes/get'
import { LMCRequest as LmcRequest } from './types'
import { User } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'

const list: LmcRequest<
  { result: User[] },
  { anyStatus: boolean },
  GetBaseOptions
> = () => getJSON({ url: 'carers' })

const fetch: LmcRequest<{ result: User }, { id: string, includes?: Array<string> }, GetBaseOptions> = ({
  params,
}) => {
  const includesQuery = params?.includes?.length ? `?includes[]=${params.includes.join(',')}` : ''
  return getJSON({ url: `/api/list/carers/${params?.id}${includesQuery}` })
}

export const usersRequests = {
  list,
  fetch,
}
